"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.personalData.name': 'Wykrywanie Danych Osobowych',
    'tools.personalData.description': 'Wyodrębnij i kategoryzuj dane osobowe z wiadomości użytkowników, takie jak numery telefonów, e-maile, adresy, nazwiska itp.',
};
